/**
 * GeneralEventForm constants
 */
export const FORM_NAME = 'generalEventForm';
